module.exports = __webpack_public_path__ + "static/media/dashback.c211fd4f.png";